// removed by extract-text-webpack-plugin
module.exports = {"describeForm":"hk-DescribeForm-describeForm","formFieldAreaItem":"hk-DescribeForm-formFieldAreaItem"};